import React from "react";

import { Pop, DivEm } from "@moai/core";
import s from "./version.module.scss";

import { register, unregister } from "./service-worker";

const msg = `A new version will be updated on your next visit,
or click to reload and update now`;

const forceUpdate = (registration: ServiceWorkerRegistration) => {
    console.log("sw debug", registration);
    if (!registration || !registration.waiting) return;
    registration.waiting.postMessage({ type: "SKIP_WAITING" });
    window.location.reload();
};

interface Props {
    enabled: boolean;
}

export const Version = ({ enabled }: Props) => {
    const [outdated, setOutdated] = React.useState(false);
    const update = React.useRef<() => void>(() => {});

    React.useEffect(() => {
        if (enabled === false) {
            unregister();
        } else {
            register({
                onUpdate: (registration) => {
                    update.current = () => forceUpdate(registration);
                    setOutdated(true);
                },
            });
        }
    }, [enabled]);

    if (!outdated) return null;

    return (
        <span>
            <DivEm />
            <Pop content={msg}>
                <button onClick={update.current} className={s.update}>
                    ⬆ Update Available
                </button>
            </Pop>
        </span>
    );
};
